export const AppName = "IndeeFlix";
export const primaryColor = "blue";

export const channelProfileTabMenu = [
    { title: "videos", viewOnly: true },
    { title: "clips", viewOnly: true },
    { title: "uploadVideo", viewOnly: false },
];

export const PAGE_ROUTES = {
    HOME: "/",
    CHANNEL_PAGE: "/channel",
    PROFILE_PAGE: "/profile",
    SEARCH_PAGE: "/search",
    PLAYER_PAGE: "/watch",
    LOGIN_PAGE: "/login",
    SHORT_VIDEO_PAGE: "/clips",
    UPLOAD_VIDEO_PAGE: "/video/upload",
    SUBSCRIPTIONS_PAGE: "/subscriptions",
    HISTORY_PAGE: "/history",
    MORE_OPTIONS_PAGE: "/more-options",
};

export const ROUTES_PATH = {
    CHANNEL_LANDING: `${PAGE_ROUTES.CHANNEL_PAGE}`,
    CHANNEL_PROFILE: `${PAGE_ROUTES.CHANNEL_PAGE}/profile`,
    CREATE_CHANNEL: `${PAGE_ROUTES.CHANNEL_PAGE}/create`,
    EDIT_CHANNEL: `${PAGE_ROUTES.CHANNEL_PAGE}/edit`,
    SEARCH: `${PAGE_ROUTES.SEARCH_PAGE}`,
    PLAYER: `${PAGE_ROUTES.PLAYER_PAGE}/:videoID`,
    LOGIN: `${PAGE_ROUTES.LOGIN_PAGE}`,
    USER_PROFILE: `${PAGE_ROUTES.PROFILE_PAGE}`,
};

export const NAV_OPTIONS = [
    { text: "Home", icon: "home", path: PAGE_ROUTES.HOME },
    {
        text: "Clips",
        path: PAGE_ROUTES.SHORT_VIDEO_PAGE,
        icon: "video_library",
    },
    {
        text: "Upload",
        path: PAGE_ROUTES.UPLOAD_PAGE,
        icon: "add",
    },
    {
        text: "Channel",
        path: PAGE_ROUTES.CHANNEL_PAGE,
        icon: "podcasts",
    },
    {
        text: "Subscriptions",
        path: PAGE_ROUTES.SUBSCRIPTIONS_PAGE,
        icon: "subscriptions",
    },
    // {
    //     text: "Watch History",
    //     path: PAGE_ROUTES.HISTORY_PAGE,
    //     icon: "history",
    // },
    {
        text: "More",
        icon: "more_vert",
        path: '',
    },
];

export const videoUpperLimit = 9;

export const PRIVACY_POLICY_URL = "https://sites.google.com/view/indeeclips-privacy-policy/home";

export const STATIC_PAGES = {
    ABOUT: "/about",
    PRIVACY_POLICY: "/privacy-policy",
    TERMS_OF_SERVICE: "/terms",
    CONTACT: "/contact",
    DMCA: "/dmca",
    BLOG: "/blog",
    BLOG_UPLOAD: "/blog/how-to-upload-videos",
    BLOG_GUIDELINES: "/blog/video-guidelines",
    BLOG_CREATORS: "/blog/indian-creators",
    BLOG_MONETIZATION: "/blog/video-monetization",
    BLOG_COMMUNITY: "/blog/community-rules",
    // Creator Guides (10)
    BLOG_GROW_CHANNEL: "/blog/grow-your-channel",
    BLOG_EDITING_TOOLS: "/blog/video-editing-tools",
    BLOG_THUMBNAILS: "/blog/engaging-thumbnails",
    BLOG_VIDEO_SEO: "/blog/video-seo-tips",
    BLOG_PERSONAL_BRAND: "/blog/personal-brand",
    BLOG_MONETIZATION_STRATEGIES: "/blog/monetization-strategies",
    BLOG_COPYRIGHT: "/blog/copyright-fair-use",
    BLOG_VIRAL_SHORTS: "/blog/viral-short-content",
    BLOG_ANALYTICS: "/blog/understanding-analytics",
    BLOG_COLLABORATION: "/blog/collaboration-tips",
    // Viewer Guides (5)
    BLOG_DISCOVER: "/blog/discover-content",
    BLOG_MANAGE_SUBS: "/blog/manage-subscriptions",
    BLOG_HIDDEN_FEATURES: "/blog/hidden-features",
    BLOG_REPORT: "/blog/report-content",
    BLOG_PARENTAL: "/blog/parental-controls",
    // Platform News (5)
    BLOG_VS_YOUTUBE: "/blog/indeeclips-vs-youtube",
    BLOG_FUTURE_CONTENT: "/blog/future-digital-content",
    BLOG_ROADMAP: "/blog/roadmap-2026",
    BLOG_BEHIND_SCENES: "/blog/behind-the-scenes",
    BLOG_SUCCESS_STORIES: "/blog/success-stories",
    // Industry Insights (5)
    BLOG_REGIONAL_LANGUAGE: "/blog/regional-language-content",
    BLOG_STREAMING_TECH: "/blog/streaming-technology",
    BLOG_ALGORITHMS: "/blog/recommendation-algorithms",
    BLOG_INTERNET_TRENDS: "/blog/internet-trends-india",
    BLOG_PLATFORM_ECONOMICS: "/blog/free-video-platforms",
    // Help Center
    HELP: "/help",
    HELP_CREATING_ACCOUNT: "/help/creating-account",
    HELP_SETTING_UP_PROFILE: "/help/setting-up-profile",
    HELP_UNDERSTANDING_HOMEPAGE: "/help/understanding-homepage",
    HELP_SEARCHING_VIDEOS: "/help/searching-videos",
    HELP_WATCHING_VIDEOS: "/help/watching-videos",
    HELP_SUBSCRIBING: "/help/subscribing-channels",
    HELP_WATCH_HISTORY: "/help/watch-history",
    HELP_BLOCKING: "/help/blocking-content",
    HELP_REPORTING: "/help/reporting-content",
    HELP_CREATING_CHANNEL: "/help/creating-channel",
    HELP_UPLOADING_VIDEOS: "/help/uploading-videos",
    HELP_UPLOADING_CLIPS: "/help/uploading-clips",
    HELP_CONTENT_GUIDELINES: "/help/content-guidelines",
    HELP_CHANNEL_ANALYTICS: "/help/channel-analytics",
    HELP_MANAGING_VIDEOS: "/help/managing-videos",
    HELP_CHANGING_PASSWORD: "/help/changing-password",
    HELP_UPDATING_PROFILE: "/help/updating-profile",
    HELP_DELETING_ACCOUNT: "/help/deleting-account",
    // FAQ
    FAQ: "/faq",
};